import vuewidget from './vuewidget'
import VoucherList from '@/components/VoucherList'
import VoucherSummary from '@/components/VoucherSummary'

export default function (dom, opts) {
  const options = {
    voucherSel: '#vouchers',
    summarySel: '#summary',
    errorSel: '#voucher-error',
    voucherDataSel: '#voucherdata',
    portoDataSel: '#shippingdata',
    vouchers: [],
    porto: [],
    language: 'de',
    showCls: 'voucher-error--show',
    ...opts
  }

  let sharedState = null

  init()

  function init () {
    let vouchers = options.vouchers
    let porto = options.porto
    const voucherDataEl = dom.querySelector(options.voucherDataSel)
    const portoDataEl = dom.querySelector(options.portoDataSel)
    if (voucherDataEl) {
      try {
        vouchers = JSON.parse(voucherDataEl.innerHTML.replace(/\s+/, ''))
      } catch (err) {
        console.error('voucherdata is corrupt')
      }
    }
    if (portoDataEl) {
      try {
        porto = JSON.parse(portoDataEl.innerHTML);
      } catch (err) {
        console.error('shipping data error')
      }
    }
    sharedState = {
      vouchers: vouchers.map(v => ({ quantity: 0, ...v })),
      porto: porto.map(p => ({quantity: 0, ...p})),
      validBasket: false
    }

    // eslint-disable-next-line no-unused-vars
    const widgetList = vuewidget(dom.querySelector(options.voucherSel), {
      vueComponent: VoucherList,
      sharedData: sharedState,
      ...opts
    })

    const widgetSummary = vuewidget(dom.querySelector(options.summarySel), {
      vueComponent: VoucherSummary,
      sharedData: sharedState,
      ...opts
    })

    // listen for valid basket
    widgetSummary.$watch('shared.validBasket', updateValidBasket)

    getForm().addEventListener('submit', onSubmit)

    updateValidBasket(sharedState.validBasket)
  }

  function getSubmitButton () {
    return dom.querySelector('input[type=submit],button[type=submit]')
  }

  function getForm () {
    return dom.tagName === 'FORM' ? dom : dom.querySelector('form')
  }

  function getErrorDisplay () {
    return dom.querySelector(options.errorSel)
  }

  function updateValidBasket (v) {
    //getSubmitButton().disabled = !v
  }
  function onSubmit (e) {
    if (!sharedState.validBasket) {
      e.preventDefault()

      const displayError = getErrorDisplay()
      displayError.innerHTML = options.i18n[options.language]["vouchers.error.basketEmpty"] || "Keine Produkte selektiert"
      displayError.classList.add(options.showCls)

    } else {
      displayError.classList.remove(options.showCls)
    }
  }
}
